/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {AccountShortInfo} from '../models/AccountShortInfo';
import type {Error} from '../models/Error';

export interface GetAccountsByName$Request {
    accountName: string;
}

export interface GetAccountsByName$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getAccountsByNameRequest = createAction<PayloadData<void, GetAccountsByName$Request>>('GET_ACCOUNTS_BY_NAME__GET_ACCOUNTS_BY_NAME__REQUEST');
export const getAccountsByNameSuccess = createAction<PayloadData<Array<AccountShortInfo>, GetAccountsByName$Request>>('GET_ACCOUNTS_BY_NAME__GET_ACCOUNTS_BY_NAME__SUCCESS');
export const getAccountsByNameFailure = createAction<PayloadData<Error, GetAccountsByName$Request, true>>('GET_ACCOUNTS_BY_NAME__GET_ACCOUNTS_BY_NAME__FAILURE');

export const getAccountsByNameActions = [
    getAccountsByNameRequest,
    getAccountsByNameSuccess,
    getAccountsByNameFailure
] as const;

/**
 * @param {string} meta.accountName Account name
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getAccountsByName = (meta: GetAccountsByName$Request, config?: GetAccountsByName$Config) => {
    const TRANSPORT_GET_PARAMS = {
        accountName: meta.accountName,
    };
    return {
        CALL_API: {
            types: getAccountsByNameActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/accounts/names/search`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

